<div [formGroup]="appForm" class="row">
  <div class="col-5 col-lg-4 col-xl-3">
    <label for="user-app-{{ inputId }}" class="form-label m-0">
    </label>

    <select id="user-app-{{ inputId }}"
      formControlName="applicationId"
      class="form-select"
      >
      @if (isAvailable) {
        @for (app of availableApplications; track app) {
          <option
            [disabled]="checkIfDisabled(app)"
            [value]="app.id"
            [innerHTML]="app.identifier ? ('apps.' + app.identifier | translate) : app.name"
            >
          </option>
        }
      }
      @if (!isAvailable) {
        <option disabled [value]="appForm.controls.applicationId.value">
          {{ 'apps.' + appForm.controls.identifier.value | translate }}
        </option>
      }
    </select>
  </div>

  <div class="col-6 col-lg-7 col-xl-8">
    <label for="application-{{ inputId }}-roles"></label>
    <div class="form-selectgroup">
      @for (role of availableRoles; track role; let roleIdx = $index) {
        <label
          class="form-selectgroup-item"
          >
          <input type="checkbox"
            name="role-{{ inputId }}-{{ roleIdx }}"
            [value]="role.name"
            [checked]="checkIfSelected(role.name)"
            (change)="onCheckboxSelected($event, role.name)"
            [disabled]="role.disabled"
            class="form-selectgroup-input" />
            <span class="form-selectgroup-label">
              <span [appRoleNameTranslation]="role.name"></span>
            </span>
          </label>
        }
      </div>
    </div>

    <div class="col-1 text-end pt-1">
      @if (appForm.enabled) {
        <i
          class="fa-regular fa-xmark fa-xl cursor-pointer"
          (click)="removeApplicationEntry()"
        ></i>
      }
    </div>
  </div>